import { useContent } from "@/lib/api";

// Real partner logos extracted from rccdinc.com, downloaded to /assets/partners.
// Admin can add / remove / replace these through /adminportal → Partners.
const SVG_INDICES = new Set(['01', '02', '04', '05', '09', '10', '11', '13', '14']);
const extensionFor = (num) => {
  if (SVG_INDICES.has(num)) return 'svg';
  if (num === '08') return 'jpg';
  return 'png';
};
const FALLBACK_PARTNERS = Array.from({ length: 15 }, (_, i) => {
  const num = String(i + 1).padStart(2, '0');
  return { name: `Partner ${num}`, image: `/assets/partners/p${num}.${extensionFor(num)}` };
});

export const PartnersMarquee = () => {
  const partners = useContent("partners", FALLBACK_PARTNERS);
  const visible = partners.filter((p) => p && p.image);
  // Duplicate so the marquee can scroll seamlessly via -50% translate.
  const rail = visible.length > 0 ? [...visible, ...visible] : [];

  return (
    <section className="py-14 lg:py-20 bg-paper border-y border-border overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 mb-8 lg:mb-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4">
          <div className="max-w-xl">
            <span className="mono text-[10px] uppercase tracking-[0.25em] text-clay">Builders &amp; partners</span>
            <h3 className="font-display text-2xl lg:text-3xl text-ink mt-2 tracking-[-0.01em]">
              In good company across <em className="font-light">Southern California.</em>
            </h3>
          </div>
          <p className="mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
            {visible.length} firms · NMC consortium · Southern California
          </p>
        </div>
      </div>

      {/* Marquee rail — uniform tile size for symmetry */}
      <div className="relative">
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 lg:w-40 z-10 bg-gradient-to-r from-paper to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 lg:w-40 z-10 bg-gradient-to-l from-paper to-transparent" />

        <div className="flex marquee whitespace-nowrap items-center">
          {rail.map((p, i) => (
            <div
              key={`${p.image}-${i}`}
              className="shrink-0 flex items-center justify-center opacity-75 hover:opacity-100 transition-opacity"
              style={{ width: '160px', height: '80px', padding: '0 28px' }}
            >
              <img
                src={p.image}
                alt={p.name || ""}
                aria-hidden={!p.name}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                className="filter grayscale hover:grayscale-0 transition-[filter] duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
